function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9958 5.00581C13.2691 5.27917 13.2691 5.72239 12.9958 5.99576L5.99576 12.9958C5.72239 13.2691 5.27917 13.2691 5.00581 12.9958C4.73244 12.7224 4.73244 12.2792 5.00581 12.0058L12.0058 5.00581C12.2792 4.73244 12.7224 4.73244 12.9958 5.00581Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.00581 5.00581C5.27917 4.73244 5.72239 4.73244 5.99576 5.00581L12.9958 12.0058C13.2691 12.2792 13.2691 12.7224 12.9958 12.9958C12.7224 13.2691 12.2792 13.2691 12.0058 12.9958L5.00581 5.99576C4.73244 5.72239 4.73244 5.27917 5.00581 5.00581Z",
  fill: "white"
});

var SvgMultiSelectboxRemove = function SvgMultiSelectboxRemove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#9698A4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMultiSelectboxRemove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/multiSelectboxRemove.532a3ca0.svg";
export { ForwardRef as ReactComponent };